module.exports = __webpack_public_path__ + "static/media/2 hanya oni mask japanese demon dark tattoo.1280x1707.b27b7df4.webp";